<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pb-12">

    <Head>
      <Title>{{ metaTitle }} - BokaBord.se</Title>
      <Meta name="description" :content="metaDescription" />
      <!-- <Meta name="og:image" :content="post?.meta?.image" /> -->
    </Head>
    <AtomPageHeader class="mt-2 lg:mt-8" :heading="heading" :leading="leading" />
    <PostsList class="mt-6" :heading="heading" :leading="leading" />
  </div>
</template>

<script setup>
const { t } = useI18n()
const app = useAppStore()
const fat = useFatStore()
const route = useRoute()

const prefixedCity = usePrefixedCityName(fat.city?.name)

// Use config from app store to get category and city
const category = computed(() => app.categories?.find(cat => cat.slug === route.params.all[0]))
const city = computed(() => app.cities?.find(city => city.slug === route.params.all[1]))

// Define meta data
const metaTitle = computed(() => city?.value
  ? t(`pages.postsCity.${category.value.slug}.meta.title`, { city: city?.value.name, prefixedCity })
  : category.value?.meta?.title)

const metaDescription = computed(() => city?.value
  ? t(`pages.postsCity.${category.value.slug}.meta.description`, { city: city?.value.name, prefixedCity })
  : category.value?.meta?.description)

// Define heading and leading
const heading = computed(() => city?.value
  ? t(`pages.postsCity.${category.value.slug}.heading`, { city: city?.value.name, prefixedCity })
  : category.value?.title)

const leading = computed(() => city?.value
  ? t(`pages.postsCity.${category.value.slug}.leading`, { city: city?.value.name, prefixedCity })
  : category.value?.excerpt)
</script>